import React, { useState } from 'react';

const MODES = [
    { value: 'strict',   label: 'Strict',   desc: 'Always follows flow. Off-topic → gentle redirect.' },
    { value: 'hybrid',   label: 'Hybrid',   desc: 'Flow + RAG coexist. Intent-based routing.' },
    { value: 'rag_only', label: 'RAG Only', desc: 'Pure knowledge base. Flow controls greeting only.' },
];

const CHANNELS = [
    { value: 'whatsapp', label: 'WhatsApp' },
    { value: 'web',      label: 'Web Chatbot' },
    { value: 'both',     label: 'Both' },
];

const LANGUAGES = [
    { value: 'en', label: 'English' },
    { value: 'hi', label: 'Hindi' },
    { value: 'mr', label: 'Marathi' },
    { value: 'ta', label: 'Tamil' },
    { value: 'te', label: 'Telugu' },
    { value: 'ar', label: 'Arabic' },
];

export default function FlowConfigPanel({ config, onChange }) {
    const [open,     setOpen]     = useState(true);
    const [tagInput, setTagInput] = useState('');

    const update = (key, val) => onChange({ ...config, [key]: val });

    const addTag = () => {
        const t = tagInput.trim().toLowerCase().replace(/\s+/g, '_');
        if (!t) return;
        const existing = config.rag_tags || [];
        if (!existing.includes(t)) update('rag_tags', [...existing, t]);
        setTagInput('');
    };

    const removeTag = (tag) => update('rag_tags', (config.rag_tags || []).filter(t => t !== tag));

    return (
        <div style={{ background:'#fff', border:'1px solid #e5e7eb', borderRadius:12, marginBottom:16, overflow:'hidden' }}>
            <button onClick={() => setOpen(p => !p)}
                style={{ width:'100%', display:'flex', alignItems:'center', justifyContent:'space-between', padding:'12px 16px', background:'#f8fafc', borderBottom: open ? '1px solid #e5e7eb' : 'none', cursor:'pointer', border:'none' }}>
                <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                    <span style={{ fontSize:13, fontWeight:700, color:'#111827' }}>Flow Configuration</span>
                    <span style={{ fontSize:11, padding:'2px 8px', borderRadius:20, background:'#eff6ff', color:'#1565c0', fontWeight:600 }}>
                        {config.mode || 'hybrid'}
                    </span>
                </div>
                <i className={`bi bi-chevron-${open ? 'up' : 'down'}`} style={{ color:'#6b7280', fontSize:12 }}></i>
            </button>

            {open && (
                <div style={{ padding:16, display:'flex', flexDirection:'column', gap:14 }}>
                    {/* Mode */}
                    <div>
                        <label style={lbl}>Conversation Mode</label>
                        <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
                            {MODES.map(m => (
                                <button key={m.value} onClick={() => update('mode', m.value)}
                                    style={{ display:'flex', alignItems:'flex-start', gap:10, padding:'10px 12px', borderRadius:8, border:`2px solid ${config.mode===m.value ? '#1565c0':'#e5e7eb'}`, background: config.mode===m.value ? '#eff6ff':'#fff', cursor:'pointer', textAlign:'left', transition:'all 0.15s' }}>
                                    <div style={{ width:16, height:16, borderRadius:'50%', border:`2px solid ${config.mode===m.value ? '#1565c0':'#d1d5db'}`, background: config.mode===m.value ? '#1565c0':'#fff', flexShrink:0, marginTop:1, display:'flex', alignItems:'center', justifyContent:'center' }}>
                                        {config.mode===m.value && <div style={{ width:6, height:6, borderRadius:'50%', background:'#fff' }}/>}
                                    </div>
                                    <div>
                                        <p style={{ fontSize:12, fontWeight:600, color:'#111827', marginBottom:2 }}>{m.label}</p>
                                        <p style={{ fontSize:11, color:'#6b7280' }}>{m.desc}</p>
                                    </div>
                                </button>
                            ))}
                        </div>
                    </div>

                    {/* RAG Tags */}
                    {(config.mode === 'hybrid' || config.mode === 'rag_only') && (
                        <div>
                            <label style={lbl}>RAG Tags (Knowledge Base Scope)</label>
                            <div style={{ display:'flex', gap:6, flexWrap:'wrap', marginBottom:8 }}>
                                {(config.rag_tags || []).map(t => (
                                    <span key={t} style={{ display:'inline-flex', alignItems:'center', gap:4, padding:'3px 10px', background:'#eff6ff', color:'#1565c0', borderRadius:20, fontSize:11, fontWeight:600, fontFamily:'monospace' }}>
                                        {t}
                                        <button onClick={() => removeTag(t)} style={{ background:'none', border:'none', cursor:'pointer', color:'#9ca3af', padding:0, fontSize:12 }}>×</button>
                                    </span>
                                ))}
                            </div>
                            <div style={{ display:'flex', gap:6 }}>
                                <input value={tagInput} onChange={e => setTagInput(e.target.value)}
                                    onKeyDown={e => e.key === 'Enter' && addTag()}
                                    placeholder="e.g. home_loan"
                                    style={inp}/>
                                <button onClick={addTag} style={{ padding:'7px 12px', background:'#1565c0', color:'#fff', border:'none', borderRadius:8, fontSize:12, fontWeight:600, cursor:'pointer' }}>
                                    <i className="bi bi-plus-lg"></i>
                                </button>
                            </div>
                        </div>
                    )}

                    {/* Language */}
                    <div>
                        <label style={lbl}>Default Language</label>
                        <select value={config.language || 'en'} onChange={e => update('language', e.target.value)} style={inp}>
                            {LANGUAGES.map(l => <option key={l.value} value={l.value}>{l.label}</option>)}
                        </select>
                    </div>

                    {/* Channel */}
                    <div>
                        <label style={lbl}>Channel</label>
                        <select value={config.channel || 'whatsapp'} onChange={e => update('channel', e.target.value)} style={inp}>
                            {CHANNELS.map(c => <option key={c.value} value={c.value}>{c.label}</option>)}
                        </select>
                    </div>

                    {/* Fallback */}
                    <div>
                        <label style={lbl}>Fallback Message</label>
                        <textarea value={config.fallback_message || ''} onChange={e => update('fallback_message', e.target.value)}
                            placeholder="e.g. Let me connect you to an agent right away."
                            rows={2} style={{ ...inp, resize:'vertical' }}/>
                    </div>
                </div>
            )}
        </div>
    );
}

const lbl = { fontSize:11, fontWeight:700, color:'#6b7280', display:'block', marginBottom:6, textTransform:'uppercase', letterSpacing:'0.06em' };
const inp = { width:'100%', padding:'8px 10px', border:'1px solid #e5e7eb', borderRadius:8, fontSize:12, color:'#111827', outline:'none', cursor:'pointer', boxSizing:'border-box', fontFamily:'inherit' };
